// AUTO-GENERATED — This file is generated code that can be modified.
//     To regenerate: `just codegen-experiment-function --experiment projects-sidebar-creation --frontend-client --target-app ask`
//     Note: Manual changes will be lost if regenerated.
import { makeBooleanFlagValueHook } from '#pplx/frontend/experimentation/hooks.js';
export const useProjectsSidebarCreationVariation = makeBooleanFlagValueHook('projects-sidebar-creation');
//# sourceMappingURL=useProjectsSidebarCreationVariation.js.map